import {
    ACTUALIZAR_BLOQUEADOS,
    CARGANDO_BLOQUEADOS,
    ERROR_BLOQUEADOS
} from "./bloqueadosReservaAction";

const bloqueadosReservaReducer = (state, action) => {
    switch (action.type) {

        case ACTUALIZAR_BLOQUEADOS: {
            return {
                ...state,
                bloqueados: action.payload,
                cargando: false,
                error: ""
            }
        }

        case CARGANDO_BLOQUEADOS: {
            return {
                ...state,
                cargando: true,
                error: ""
            }
        }

        case ERROR_BLOQUEADOS: {
            return {
                ...state,
                cargando: false,
                error: action.payload
            }
        }

        default:
            return state;
    }
}

export default bloqueadosReservaReducer;
